@let term = invoice().collectiveInvoiceIssueTerm;
@if (term) {
  {{ label() | translate }}:
  @if (term === CollectiveInvoiceIssueTerm.SELECTED_DAY) {
    {{ invoice().collectiveInvoiceIssueSelectedDay }}.
    {{ 'labels.dayOfMonthAfterFinish' | translate | lowercase }}
  } @else {
    {{ `${DictionaryCode.COLLECTIVE_INVOICE_ISSUE_TERM}.${term}` | translate }}
  }
}
